__turbopack_context__.v({
  "wrapper": "TaxYearlyReportList-module-scss-module__ML7_iW__wrapper",
});
